import { render, staticRenderFns } from "./ChatGroupJoinGroup.vue?vue&type=template&id=749be169&scoped=true&lang=pug"
import script from "./ChatGroupJoinGroup.vue?vue&type=script&lang=js"
export * from "./ChatGroupJoinGroup.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupJoinGroup.vue?vue&type=style&index=0&id=749be169&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749be169",
  null
  
)

export default component.exports